import { combineReducers } from "redux";
import project from "./project";

const rootReducer = combineReducers({
  project,
});

export default rootReducer;
export type State = ReturnType<typeof rootReducer>;
